// Lead capture api token
export const LEAD_CAPTURE_TOKEN =
  process.env.LEAD_CAPTURE_TOKEN ||
  process.env.DEFAULT_AUTH_TOKEN ||
  "94c68c7ddb649e0a22582fc6787381b22399ca6d";

export const LEAD_CAPTURE_CARS24_TOKEN =
  process.env.LEAD_CAPTURE_CARS24_TOKEN ||
  process.env.DEFAULT_AUTH_TOKEN ||
  "a48c6647ac48a4d51983608e219556c3f20bebac";

// OLX Constants
export const OLX_MAIN = "olx";
export const OLX_CHAT = "olxchat";
export const OLX_CENTRE = "olxcentre";
export const ACKODRIVE_LP = "ackodrivelp";

export const OLX_TOKEN =
  process.env.OLX_TOKEN ||
  process.env.DEFAULT_AUTH_TOKEN ||
  "f8ddd3654caf486789eb038de74b6986b501136d";

export const OLX_CHAT_TOKEN =
  process.env.OLX_CHAT_TOKEN ||
  process.env.DEFAULT_AUTH_TOKEN ||
  "c37c7302f0e142cb709ee025462225907d3adf0e";

export const OLX_CENTRE_TOKEN =
  process.env.OLX_CENTRE_TOKEN ||
  process.env.DEFAULT_AUTH_TOKEN ||
  "8ecf99901abb5639debdd0e3793545e063fdae0f";

export const ACKODRIVE_LP_TOKEN =
  process.env.ACKODRIVE_LP_TOKEN ||
  process.env.DEFAULT_AUTH_TOKEN ||
  "283276ab240affac94b0abf832c1cc251b4df38b";

// SEM Constants
export const SEM_LP = "SEM_LP";
export const SEM_LP_TOKEN = "283276ab240affac94b0abf832c1cc251b4df38b";

// HTTP Headers
export const X_FORWARD_FOR = "x-forwarded-for";

// Default Location Constants
export const DEFAULT_FALLBACK_CITY = {
  cityId: 3,
  cityName: "Delhi",
  ip_city: "NOT_ESTIMATED",
  citySlug: "delhi",
};

export const DEFAULT_FALLBACK_CITY_WITHOUT_IP = {
  cityId: 3,
  cityName: "Delhi",
  citySlug: "delhi",
};


// IP City Constants
export const IP_CITY_KEY = "ip_city";
export const IP_CITY_FETCH_ROUTE = "/api/get-ip-city/";

// Lead Source Types
export const LEAD_SOURCES = {
  CARS24: "Cars 24",
  OLX_MAIN,
  OLX_CHAT,
  OLX_CENTRE,
  ACKODRIVE_LP,
  SEM_LP,
} as const;

export type LeadSourceType = typeof LEAD_SOURCES[keyof typeof LEAD_SOURCES]; 